import { computed, defineComponent, onMounted, ref, onBeforeUnmount, reactive, getCurrentInstance } from "vue";
import { PlatformEnum, deviceConfig, OrientationEnum } from "./config";
import Qrcode from "@/components/Qrcode/index.vue";
import { updateUrlParam } from "@/utils/index";
// import PlPointLayer from '@com/components/pl-point-layer/index.vue'
export default defineComponent({
    components: {
        Qrcode: Qrcode
    },
    setup: function setup() {
        var px2Rem = function px2Rem(size) {
            var mobilePercent = 1;
            var retinaNumber = viewType.value === "mobile" ? mobilePercent : 1 // 终端缩放比例
            ;
            return String(size / 100 / retinaNumber) + "rem";
        };
        var getQueryString = function getQueryString(name) {
            var query = root.$route.query;
            return query[name] ? query[name] : null;
        };
        var adjustPreview = function adjustPreview() {
            if (viewportWidth.value < 1100) {
                viewType.value = "mobile";
                showMenu.value = false;
            } else {
                viewType.value = "pc";
                showMenu.value = true;
            }
        };
        var switchLang = function switchLang() {
            url.value = updateUrlParam(url.value, "lang", currentLang.value);
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var url = ref("");
        var name1 = ref("");
        var orientation = ref(3);
        var language1 = ref("");
        var currentLang = ref("");
        var viewportWidth = ref(window.innerWidth);
        var actions = reactive({});
        var resizeTimer = ref();
        var viewType = ref("") // mobile pc
        ;
        var orientationType = ref(OrientationEnum.Vertical) // 1 Vertical 2 Horizontal 3 Auto
        ;
        var platformType = ref(PlatformEnum.Iphone);
        var showMenu = ref(false);
        var isHorizontal = computed(function() {
            return Number(orientationType.value) === OrientationEnum.Horizontal;
        });
        var scaleNumber = computed(function() {
            // 根据不同屏幕宽度，分档次缩放
            var size;
            // 移动竖屏
            var isMobileVertical = viewType.value === "mobile" && !isHorizontal.value;
            // 移动横屏
            var isMobileHorizontal = viewType.value === "mobile" && isHorizontal.value;
            switch(true){
                case viewType.value === "pc":
                    size = 0.6;
                    break;
                case isMobileHorizontal && viewportWidth.value <= 320:
                    size = 0.55 / 2;
                    break;
                case isMobileHorizontal && viewportWidth.value <= 375:
                    size = 0.7 / 2;
                    break;
                case isMobileHorizontal && viewportWidth.value <= 414:
                    size = 0.75 / 2;
                    break;
                case isMobileVertical && viewportWidth.value <= 320:
                    size = 0.75 / 2;
                    break;
                case isMobileVertical && viewportWidth.value <= 375:
                    size = 0.9 / 2;
                    break;
                case isMobileVertical && viewportWidth.value <= 414:
                    size = 1 / 2;
                    break;
                default:
                    size = 0.75 / 2;
                    break;
            }
            return size;
        });
        // 当前选中设备
        var curDevice = computed(function() {
            return deviceConfig[platformType.value];
        });
        var viewerStyle = computed(function() {
            return {
                width: px2Rem(curDevice.value.screen[isHorizontal.value ? 1 : 0]),
                height: px2Rem(curDevice.value.screen[isHorizontal.value ? 0 : 1]),
                marginLeft: px2Rem(-curDevice.value.screen[isHorizontal.value ? 1 : 0] / 2),
                marginTop: px2Rem(-curDevice.value.screen[isHorizontal.value ? 0 : 1] / 2),
                transform: "scale(" + scaleNumber.value + ")"
            };
        });
        var coverStyle = computed(function() {
            return {
                width: px2Rem(curDevice.value.cover["width"]),
                height: px2Rem(curDevice.value.cover["height"]),
                top: px2Rem(-(curDevice.value.cover["height"] - curDevice.value.screen[isHorizontal.value ? 0 : 1]) / 2),
                left: px2Rem(-(curDevice.value.cover["width"] - curDevice.value.screen[isHorizontal.value ? 1 : 0]) / 2),
                transform: isHorizontal.value ? "rotate(-90deg)" : ""
            };
        });
        // 固定iframe宽高绝对值，部分素材无法根据100%适配宽高
        var gameIframeStyle = computed(function() {
            return {
                width: px2Rem(curDevice.value.screen[isHorizontal.value ? 1 : 0]),
                height: px2Rem(curDevice.value.screen[isHorizontal.value ? 0 : 1])
            };
        });
        var gameIframeAttr = computed(function() {
            return {
                width: curDevice.value.screen[isHorizontal.value ? 1 : 0],
                height: curDevice.value.screen[isHorizontal.value ? 0 : 1]
            };
        });
        // 改变方向
        var changeOrientation = function(e) {
            if (e.target) {
                orientationType.value = Number(e.target.dataset.value);
                adjustPreview();
            }
        };
        // 改变设备
        var changePlatform = function(e) {
            if (e.target) {
                platformType.value = e.target.dataset.value;
                adjustPreview();
            }
        };
        // 改变语言
        var changeLanguage = function(language) {
            currentLang.value = language;
            switchLang();
        };
        // 改变视口大小
        var updateWindowWidth = function() {
            viewportWidth.value = window.innerWidth // 更新为当前窗口宽度
            ;
            if (viewportWidth.value < 1100) {
                showMenu.value = false;
            }
            clearTimeout(resizeTimer.value);
            resizeTimer.value = setTimeout(function() {
                adjustPreview();
            }, 200);
        };
        var handleRefresh = function() {
            console.log("showMenu\uFF01\uFF01\uFF01\uFF01\uFF01\uFF01\uFF01", showMenu.value);
            root.$router.go(0);
        };
        var handlePlay = function() {
            window.open("".concat(url.value, "&lang=").concat(currentLang.value), "_blank");
        };
        var qrcodeAttrs = computed(function() {
            return {
                text: "".concat(url.value, "&is_browser_tips=1")
            };
        });
        onMounted(function() {
            var app = document.getElementById("app");
            if (app) app.style.width = "100vw";
            document.body.style.minWidth = "0";
            var html = document.querySelector("html");
            html.style.fontSize = "100px";
            // 获取url上的语言（零个或多个语言）
            language1.value = getQueryString("language") ? getQueryString("language").split(",") : "";
            url.value = "".concat(getQueryString("url")).concat(language1.value ? "&lang=".concat(language1.value[0]) : "");
            name1.value = getQueryString("name") || "";
            orientation.value = Number(getQueryString("orientation")) || 3;
            orientationType.value = orientation.value === OrientationEnum.Horizontal ? OrientationEnum.Horizontal : OrientationEnum.Vertical;
            currentLang.value = language1.value ? language1.value[0] : "";
            adjustPreview();
            window.addEventListener("resize", updateWindowWidth);
        });
        onBeforeUnmount(function() {
            var html = document.querySelector("html");
            html.style.fontSize = "";
            window.removeEventListener("resize", updateWindowWidth);
        });
        return {
            url: url,
            name: name1,
            orientation: orientation,
            language: language1,
            currentLang: currentLang,
            orientationType: orientationType,
            platformType: platformType,
            viewerStyle: viewerStyle,
            gameIframeStyle: gameIframeStyle,
            gameIframeAttr: gameIframeAttr,
            coverStyle: coverStyle,
            OrientationEnum: OrientationEnum,
            showMenu: showMenu,
            viewportWidth: viewportWidth,
            qrcodeAttrs: qrcodeAttrs,
            actions: actions,
            changeOrientation: changeOrientation,
            changePlatform: changePlatform,
            changeLanguage: changeLanguage,
            handleRefresh: handleRefresh,
            handlePlay: handlePlay
        };
    }
});
